import {Component} from '@angular/core';
import {
  ActivityIndicatorWithMessages
} from "../../../lib/activity-indicator-with-messages/activity-indicator-with-messages.component";
import {ToolsInfo} from "../../../lib/models/tools.models";
import {ToolsService} from "../../../lib/services/tools.service";

@Component({
  selector: 'ms-tools',
  templateUrl: './tools.component.html',
  styleUrls: ['./tools.component.scss'],
  standalone: false
})
export class ToolsComponent {
  public isLoading: boolean = false;
  public messages: Array<ActivityIndicatorWithMessages> = [];

  constructor(
    private toolsService: ToolsService,
  ) {

  }

  private availableTools: Array<ToolsInfo> = [
    {
      name: 'createDataBase',
      creationDate: '2025-09-06',
      title: 'Créer une nouvelle base de données',
      description: "Créer une nouvelle base de données",
      isActive: true
    }
  ];

  public toolsList: Array<ToolsInfo> = [];
  public displayedColumns: string[] = ['creationDate', 'title', 'description', 'action'];

  ngOnInit() {
    this.toolsList = this.availableTools?.filter(tool => tool.isActive);
  }
}
